module.exports = __webpack_public_path__ + "img/Bitmap2.e9d30cf7.png";